module.exports = __webpack_public_path__ + "static/img/1_2_1_3.62fae608.jpg";